var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "associate-action-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        staticClass: "header",
        attrs: { headerTitle: _vm.text.title },
      }),
      !_vm.loadedSelectItems
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      _c("LexonSelectComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadedSelectItems && !_vm.getRenderNoRegistersWarning,
            expression: "loadedSelectItems && !getRenderNoRegistersWarning",
          },
        ],
        staticClass: "lexon-select",
        attrs: {
          id: "economicData",
          name: "economicData",
          label: _vm.text.label,
          keyName: "description",
          keyValue: "id",
          returnObject: false,
          tableHeaders: _vm.tableHeaders,
          propItems: _vm.economicDataCollection,
        },
        model: {
          value: _vm.economicDataId,
          callback: function ($$v) {
            _vm.economicDataId = $$v
          },
          expression: "economicDataId",
        },
      }),
      _vm.loadedSelectItems && _vm.getRenderNoRegistersWarning
        ? _c("div", { staticClass: "info-message-container" }, [
            _c("div", { staticClass: "info-message" }, [
              _c("span", { class: [_vm.infoIcon, "icon"] }),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.text.noEconomicData)),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.loadedSelectItems
        ? _c("CustomDialogActionButtonsComponent", {
            staticClass: "actions",
            attrs: {
              primaryButtonText: _vm.text.save,
              mainAction: _vm.saveAssociation,
              disabledButtons: !_vm.economicDataId,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }